export enum SafePageState {
    Waiting,
    Scanning,
    Typing,
    Sending,
    Result,
    Error
}